import { c as _c } from "react/compiler-runtime";
import { VisualNavigation } from '../../components';
import type { VisualNavigationProps } from '../../components/Tile6Up/types';
import { BuildContextProvider } from '../../providers';
export function VisualNavigationSection(t0) {
  const $ = _c(2);
  const {
    tiles
  } = t0;
  let t1;
  if ($[0] !== tiles) {
    t1 = <BuildContextProvider><VisualNavigation variant="VisualNav" tiles={tiles} /></BuildContextProvider>;
    $[0] = tiles;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}